// extracted by mini-css-extract-plugin
export var component = "TitleForDynamicParagraphs-module--component--09085";
export var fadePop = "TitleForDynamicParagraphs-module--fade-pop--0e79f";
export var growHeightIn = "TitleForDynamicParagraphs-module--grow-height-in--55ff0";
export var hr = "TitleForDynamicParagraphs-module--hr--e1327";